import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import type { BreadcrumbNode } from '@amplience/content-types/typings/h-breadcrumb-node';
import type { AncestorCategory, Category } from '@storefront/lib-global/codegen/types';
import { Breadcrumb, Item } from './ProductListBreadcrumb.styles';

export type BreadcrumbDataType = {
  content: BreadcrumbNode;
};

type ProductListBreadcrumbProps = {
  ancestors: AncestorCategory[];
  category: Category;
  hits?: number;
};

export function ProductListBreadcrumb({ ancestors, category, hits }: ProductListBreadcrumbProps) {
  const { t } = useTranslation(['lib-products-common']);
  const breadcrumbData = [{ key: '', name: t('pdp.breadcrumbs.home'), slug: 'home' }].concat(ancestors, [
    { key: category.key, name: category.name || '', slug: category.slug || '' },
  ]);
  return (
    <Breadcrumb>
      <ol>
        {breadcrumbData?.map((item, index) => (
          <Item key={`${item.slug}-${index}`}>
            <Link href={`/${item.key}${index === 0 ? '' : '-c'}`}>{`${item.name} ${
              index === breadcrumbData.length - 1 ? `(${hits} ${t('plp.breadcrumbs.results')})` : ''
            }`}</Link>
          </Item>
        ))}
      </ol>
    </Breadcrumb>
  );
}
